<div class="modal-header">
    <button type="button" class="icon-close_medium" aria-label="Close" (click)="dismissModal()"></button>
    <h5 class="modal-title">Inquiry for Accessing Content</h5>
    <div class="info">
        <span>The content you are trying to access is part of a <i>paid subscription</i> service to which you are not currently entitled.</span>
        <span>Complete the form below to explore subscription options for this content.</span>
    </div>
</div>
<form class="modal-body" [formGroup]="requestAccessFormModal" (ngSubmit)="onModalClose()">
    <div class="name">
        <app-input [props]="inputProps['FirstName']" formControlName="FirstName" (blurInput)="updateControlValidity('FirstName')"></app-input>
        <app-input [props]="inputProps['LastName']" formControlName="LastName" (blurInput)="updateControlValidity('LastName')"></app-input>
    </div>
    <app-input [props]="inputProps['Email']" formControlName="Email" (blurInput)="updateControlValidity('Email')"></app-input>
    <app-input [props]="inputProps['PhoneNumber']" formControlName="PhoneNumber" (blurInput)="updateControlValidity('PhoneNumber')"></app-input>
    <app-text-area [props]="inputCommentProps" formControlName="Comment"></app-text-area>
</form>
<div class="modal-footer">
    <button type="button" class="btn-modal-secondary" (click)="onModalClose()">Cancel</button>
    <button type="submit" class="btn-modal-primary" [disabled]="requestAccessFormModal.invalid" (click)="handleSendInquiry()">Send Subscription Inquiry</button>
</div>
